import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a446a18c")

_pushScopeId("data-v-a446a18c")
const _hoisted_1 = { class: "Input" }
const _hoisted_2 = {
  key: 0,
  class: "Input__label"
}
const _hoisted_3 = { class: "Input__container" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createBlock("div", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createVNode("label", _hoisted_3, [
      _createVNode("input", {
        class: "Input__container-control",
        onFocus: _cache[1] || (_cache[1] = $event => (_ctx.$emit('focus', $event))),
        onInput: _cache[2] || (_cache[2] = $event => (_ctx.$emit('update:modelValue', $event.target.value))),
        type: _ctx.type,
        value: _ctx.modelValue,
        pattern: _ctx.pattern
      }, null, 40, ["type", "value", "pattern"])
    ])
  ]))
})